import { IMenuItem, IMeta } from 'src/common/interfaces/index.js'
import businessClient from 'src/services/clients/business'

const IMenuItemBulkAddResponse = { meta: IMeta, data: { insert: [IMenuItem], update: [IMenuItem] } }
const IMenuItemListResponse = {
  meta: IMeta,
  data: {
    list: [
      {
        id: 16,
        menu_item_id: 16,
        menu_item_name: 'French Fries 6',
        menu_item_category_id: 9,
        is_archive: false,
        is_active: true,
        price: '6.000',
        default_price: '6.000',
        item_id: 12,
        item_name: '',
        availability_type: 0,
        availability: {},
        images: ['1'],
        image_type: 0,
        modifiers: [],
        description: '',
        prep_time_minute: 5,
        allergen: '',
        sell_unit: 100,
        plu: '12',
        item_tax_type: 0,
        item_tax: {},
        ord: 16,
        sell_unit_name: 'Item',
      },
    ],
    count: 0,
  },
}

export const menuItem = {
  /**
   * @param {{item_ids: number[]; category_id: number}} data
   * @return {Promise<IMenuItemBulkAddResponse>}
   */
  bulkAdd(data, signal) {
    return businessClient().post('menu/item/portal/bulk/add', { data }, { signal })
  },

  /**
   * @param {{category_id: number}} filter
   * @return {Promise<IMenuItemListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('menu/item/portal/list', { filter }, { signal })
  },

  /**
   * @param {IMenuItem} data
   * @return {Promise<IMenuItemListResponse>}
   */
  update(data, signal) {
    return businessClient().post('menu/item/portal/update', { data }, { signal })
  },

  activation(data, signal) {
    return businessClient().post('menu/item/activation', { data }, { signal })
  },

  /**
   * @param {{ids: number[]}} filter
   * @return {Promise<IMenuItemListResponse>}
   */
  remove(filter, signal) {
    return businessClient().post('menu/item/portal/remove', { filter }, { signal })
  },

  /**
   * @param {{from: number; to: number; category_id: number;}} filter
   */
  updateOrd(filter, signal) {
    return businessClient().post('menu/item/update-ord', { filter }, { signal })
  },

  /**
   * @param {{item_ids: number[], category_id: number}} filter
   */
  move(filter, signal) {
    return businessClient().post('/menu/item/portal/move', { filter }, { signal })
  },
}
